import React from 'react';
import { Box, Typography } from '@mui/material';

type CouponBoxPropsType = {
  promo: string;
};
const CouponBox: React.FC<CouponBoxPropsType> = ({ promo }) => {
  return (
    <Box
      sx={{
        width: { xs: '100%', lg: '80%' },
        textAlign: 'center',
        bgcolor: 'white',
        px: 5,
        py: 2,
        borderRadius: 2,
      }}
    >
      <Typography variant="h6" sx={{ marginBottom: '1rem', fontWeight: 'bold' }}>
        Use Promo{' '}
        <Typography
          component="span"
          variant="h5"
          sx={{ color: 'primary.main', fontWeight: 'bold' }}
        >
          {`"${promo}"`}
        </Typography>
        {' '}at Stripe checkout
      </Typography>
    </Box>
  );
};

export default CouponBox;
